<template>
  <span class="course-treatment" v-if="courseTreatmentStr">
    {{ courseTreatmentStr }}
  </span>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    diseaseId: {
      type: String | Number,
      default: "",
    },
    patientCode: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["dicts"]),
  },
  watch: {
    // diseaseId(newValue, oldValue) {
    //   this.getDaata();
    // },
    diseaseId: {
      handler() {
        this.getDaata();
      },
      immediate: true,
    }
  },
  data() {
    return {
      courseTreatmentStr: "",
    };
  },
  methods: {
    Disease_Type() {
      let list = this.dicts["Disease_Type"] || [];
      let obj = list.find((i) => i.value == this.diseaseId);
      if (obj) {
        return obj.string5 && obj.string5 != "0"
          ? `${obj.string5 +
          obj.string5Unit +
          "~" +
          obj.string6 +
          obj.string6Unit
          }`
          : "";
      } else {
        return "";
      }
    },
    dayStr(day) {
      return day > 0 ? day : "/"
    },
    getDaata() {
      this.courseTreatmentStr = "";
      let lc = this.Disease_Type();
      this.api2("getAverageCourse", {
        patientCode: this.patientCode,
        diseaseId: this.diseaseId,
      })
        .then((res) => {
          let obj = res.result || {};
          this.courseTreatmentStr = `回访首次有效未愈${this.dayStr(obj.firstNotCuredDays)}天；回访首次有效已愈${this.dayStr(obj.firstCuredAvgDays)}天；末次回访有效未愈${this.dayStr(obj.lastNotCuredAvgDays)}天；徐氏经验疗程${this.dayStr(obj.experienceDays)}天`
          // let strArr = [];
          // if (obj.improveAvgCourseDays) {
          //   strArr.push(`平均治好疗程${obj.improveAvgCourseDays}天`);
          // } else {
          //   lc && strArr.push(`平均治好疗程 ${lc}`);
          // }
          // obj.cureAvgCourseDays &&
          //   strArr.push(`平均彻底断根疗程${obj.cureAvgCourseDays}天`);
          // this.courseTreatmentStr = strArr.join("；");
        })
        .catch(() => {
          this.courseTreatmentStr = lc ? `平均治好疗程 ${lc}` : "";
        });
    },
  },
  created() {
    // this.getDaata();
  },
};
</script>

<style lang="scss" scoped>
.course-treatment {
  display: inline-block;
  font-size: 12px;
  background: #fffce0;
  display: inline-block;
  line-height: 16px;
  padding: 4px 8px;
}
</style>